<template>
  <div
    ref="siteSetupSteps"
    :class="['site-setup-steps', `step-${activeIndex}-active`]">

    <div
      class="setup-step" :to="{name: 'getStarted'}">
      <div class="step-tick">
        <Sprite v-if="!isCurrentRoute('getStarted')" name="tick"/>
      </div>

      <Sprite class="step-icon" name="chat"/>
      <div>
        <h3>Meet ProBot</h3>
        <p class="slogan">This is our powerful AI bot</p>
      </div>
    </div>

    <div
      class="setup-step"
      :to="{
        name: 'homeContent',
        params: {companyId: companyId, siteId: siteId}
      }"
    >
      <div class="step-tick">
        <Sprite v-if="!isCurrentRoute('homeContent')" name="tick"/>
      </div>

      <Sprite class="step-icon" name="magic-wand"/>
      <div>
        <h3>Make Magic Happen</h3>
        <p class="slogan">This is the clever part!</p>
      </div>
    </div>

    <div
      class="setup-step" :to="{name: 'otherContent'}">
      <div class="step-tick">
        <Sprite v-if="!isCurrentRoute('otherContent')" name="tick"/>
      </div>

      <Sprite class="step-icon" name="star"/>
      <div>
        <h3>Your Time to Shine</h3>
        <p class="slogan">You know your company best</p>
      </div>
    </div>

    <div
      class="setup-step" :to="{name: 'sitePreview'}">
      <div class="step-tick">
        <Sprite v-if="!isCurrentRoute('sitePreview')" name="tick"/>
      </div>

      <Sprite class="step-icon" name="desktop"/>
      <div>
        <h3>Your Masterpeice</h3>
        <p class="slogan">The cream of the crop</p>
      </div>
    </div>
  </div>
</template>

<script>
import Sprite from '@/components/Sprite'

export default {
  name: 'setupSteps',

  props: ['companyId', 'siteId', 'activeIndex'],

  computed: {
    isCurrentRoute() {
      return (name) => {
        return this.$route.name === name
      }
    }
  },

  components: {
    Sprite
  }
}
</script>

<style lang="sass" scoped>
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/helpers/extends'

.site-setup-steps
  display: flex
  flex-direction: column
  align-items: center
  justify-content: space-around
  height: 100%
  width: 100%

  .setup-step
    width: 100%
    height: 100%
    padding: 0 $gap-large
    display: flex
    align-items: center
    border-bottom: 1px solid $color-border-light
    color: rgba(0, 0, 0, 0.5)
    opacity: 0.25
    transition: opacity .5s ease-in-out
    position: relative

    h3
      font-weight: normal
      font-size: 18px
      margin: 0

  .step-tick
    opacity: 0
    transition: opacity .5s ease-in-out
    position: absolute
    top: $gap-medium
    right: $gap-medium

    .sprite
      fill: #61d97c
      width: 20px
      height: 20px

  .step-icon
    width: 30px
    height: 30px
    margin-right: $gap-small

    @include themify($themes)
      fill: themed('color-secondary')

.slogan
  display: block
  height: 0
  margin: 0
  overflow: hidden
  transition: height .5s ease-in-out

$slogan-height: 30px

.step-1-active
  .setup-step
    &:first-child
      opacity: 1

      .slogan
        height: $slogan-height

      .step-tick
        opacity: 1

.step-2-active
  .setup-step
    &:nth-of-type(-n+2)
      opacity: 1

      .slogan
        height: $slogan-height

      .step-tick
        opacity: 1

.step-3-active
  .setup-step
    &:nth-of-type(-n+3)
      opacity: 1

      .slogan
        height: $slogan-height

      .step-tick
        opacity: 1

.step-4-active
  .setup-step
    &:nth-of-type(-n+4)
      opacity: 1

      .slogan
        height: $slogan-height

      .step-tick
        opacity: 1

</style>
